import analyticsAction from "../../analytics/analytics-action"

type EventProps = {
  event: string
  properties?: object
}

export default function analyticsClick(el: HTMLElement, props: EventProps) {
  el.addEventListener("click", () => {
    analyticsAction(props.event, props.properties)
  })
}
